import { HttpClient } from './serviceBase';
import { utils } from '../utils/utils'

class ReplacementUnitService {
    GetReplacementUnits = async (req, config = null) => {
        const queryString = utils.GetQueryStringsFromObject(req);
        return await HttpClient.Get(`/api/Reports/ReplacementUnitsReport?${queryString}`, config);
    }

    ExportReplacementUnits = async (req) => {
        const queryString = utils.GetQueryStringsFromObject(req)
        return await HttpClient.GetFile(`/api/Reports/ReplacementUnitsReport/export?${queryString}`);
    }
} export default new ReplacementUnitService();